import React, { useState } from "react";
import { Checkbox, Form, Input, Row } from "antd";
import { MailOutline, Lock } from "@material-ui/icons";
import { useDispatch } from "react-redux";
import ReCAPTCHA from "react-google-recaptcha";
import getConfig from "next/config";

import Link from "next/link";
import Router from "next/router";
import styled from "styled-components";
import { verifyLogin } from "../store/actions/authActions";
import { displayNotification } from "../store/actions/notificationActions";
import Already from "../components/Auth/Already";
import LCButton from "./styles/LCButton";

const Content = styled.div`
  max-width: 400px;
  z-index: 2;
  min-width: 300px;
`;

const { publicRuntimeConfig } = getConfig();
const { recaptchaSiteKey } = publicRuntimeConfig;

const Signin = () => {
  const dispatch = useDispatch();

  const [recaptchaToken, seRecaptchaToken] = useState("");

  if (Router.query.auth_faild) {
    dispatch(
      displayNotification({
        type: "error",
        message: "Please sign in to further proceed.",
      })
    );
  }

  const onFinish = (values) => {
    if (recaptchaToken) {
      values.token = recaptchaToken;
      dispatch(verifyLogin(values));
    } else {
      dispatch(
        displayNotification({
          type: "error",
          message: "Please check recaptcha.",
        })
      );
    }
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  const onChange = (value) => {
    seRecaptchaToken(value);
    console.log("Captcha value:", value);
  };

  return (
    <Row
      type="flex"
      align="middle"
      justify="center"
      className="px-3 bg-white mh-page"
      style={{ minHeight: "100vh" }}>
      <Already />
      <Content>
        <div className="text-center">
          <h2 className="">Hello</h2>
          <p className="text-muted">Good to see you again!</p>
        </div>

        <Form
          layout="vertical"
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}>
          <Form.Item
            label="Email"
            name="email"
            rules={[
              { type: "email", message: "The input is not valid E-mail!" },
              { required: true, message: "Please input your E-mail!" },
            ]}>
            <Input
              prefix={
                <MailOutline
                  style={{ color: "rgba(0,0,0,.25)", fontSize: "16px" }}
                />
              }
              type="email"
              placeholder="Email"
              size="large"
            />
          </Form.Item>
          <Form.Item
            label="Password"
            name="password"
            rules={[
              { required: true, message: "Please enter your password!" },
            ]}>
            <Input.Password
              prefix={
                <Lock style={{ color: "rgba(0,0,0,.25)", fontSize: "16px" }} />
              }
              size="large"
            />
          </Form.Item>

          <Form.Item>
            <Checkbox>Remember me</Checkbox>
            <Link href="/forgot">
              <a className="text-xs-right">
                <small>Forgot password</small>
              </a>
            </Link>
            <div className="mt-3">
              <ReCAPTCHA
                sitekey={recaptchaSiteKey}
                size="normal"
                onChange={onChange}
              />
            </div>

            <LCButton
              type="primary"
              as="button"
              htmlType="submit"
              className="mt-3"
              fullWidth
              size="large">
              Log in
            </LCButton>
          </Form.Item>
          {process.env.whiteLabel ? (
            ""
          ) : (
            <div className="text-center">
              <p className="text-muted">
                <span>Don't have an account yet?</span>{" "}
                <Link href="/signup">
                  <a>&nbsp;Create one now!</a>
                </Link>
              </p>
              <p className="text-muted">
                <span>Need new confirmation email?</span>{" "}
                <Link href="/resend">
                  <a>&nbsp;Resend confirmation!</a>
                </Link>
              </p>
            </div>
          )}

          <p className="text-muted" style={{ textAlign: "center" }}>
            Get immediate keyword ranking ad optical feedback for your website.
          </p>
        </Form>
      </Content>
    </Row>
  );
};

export default Signin;
